// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"4170e008","220":"efaa2be2","223":"b47d3ee7","354":"8ce72d37","453":"b461afb0","465":"aee3c9a7","842":"eac6692d","998":"432b90c3"}[chunkId] + ".chunk.js";
};